import React, { useEffect, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IntlMessages from "util/IntlMessages";
// import { userSignIn } from "actions/Auth";
import { userSignIn2 } from "actions/Auth";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { selToken } from "store/slices";
import { makeStyles } from "@material-ui/core";
import logo from "../assets/images/enroutelogo.png";

const useStyles = makeStyles({
  logo: {
    width: "100%",
  },
  logoBg: {
    backgroundColor: "#4468c1",
  },
});
const SignIn = (props) => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const token = useSelector(selToken);
  // console.log("🚀 ~ file: SignIn.js ~ line 20 ~ SignIn ~ token", token);
  // const { loading, message } = useSelector(({ commonData }) => commonData);

  useEffect(() => {
    if (token !== null) {
      props.history.push("/");
    }
  }, [token]);
  // if (token !== null) return <Redirect to={`app/dashboard/settings`} />;

  return (
    <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
      <div className="app-login-main-content">
        <div
          className={`app-logo-content d-flex align-items-center justify-content-center ${classes.logoBg}`}
        >
          <Link className="logo-lg" to="/" title="Jambo">
            <img
              className={classes.logo}
              src={logo}
              alt="jambo"
              title="jambo"
            />
          </Link>
        </div>

        <div className="app-login-content">
          <div className="app-login-header mb-4">
            <h1>
              <IntlMessages id="appModule.login" />
            </h1>
          </div>

          <div className="app-login-form">
            <form>
              <fieldset>
                <TextField
                  label={<IntlMessages id="appModule.username" />}
                  fullWidth
                  onChange={(event) => setEmail(event.target.value)}
                  defaultValue={email}
                  margin="normal"
                  className="mt-1 my-sm-3"
                />
                <TextField
                  type="password"
                  label={<IntlMessages id="appModule.password" />}
                  fullWidth
                  onChange={(event) => setPassword(event.target.value)}
                  defaultValue={password}
                  margin="normal"
                  className="mt-1 my-sm-3"
                />

                <div className="mb-3 d-flex align-items-center justify-content-between">
                  <Button
                    onClick={() => {
                      dispatch(userSignIn2({ email, password }));
                    }}
                    variant="contained"
                    color="primary"
                  >
                    <IntlMessages id="appModule.signIn" />
                  </Button>

                  <Link to="/forgot-password">
                    <IntlMessages id="appModule.forgotpassword" />
                  </Link>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>

      {/* {loading && (
        <div className="loader-view">
          <CircularProgress />
        </div>
      )}
      {message && NotificationManager.error(message)}
      <NotificationContainer /> */}
    </div>
  );
};

export default SignIn;
